<template>

<div id="" class="leftmenu model-single" v-if="model && !is_fetching_content">


    <a v-if="lastModelListPageRoute !== undefined" :href="'javascript:history.go('+lastModelListPageRoute+')'" class="lm-link lm-backbtn trigger-nav-back">
        Back
    </a>

    <router-link v-if="lastModelListPageRoute === undefined && lastRoute" :to="lastRoute.fullPath" class="lm-link lm-backbtn trigger-nav-back">
        Back
    </router-link>
    
    <router-link v-if="lastModelListPageRoute === undefined && !lastRoute" :to="'/news'" class="lm-link lm-backbtn trigger-nav-back">
        Back
    </router-link>
    

    <h1 class="lm-h1">
        <span class="styled">
            {{model.first_name}}
        </span>
        <span class="straight">
            {{model.last_name}}
        </span>
    </h1>

    <template v-if="book_visible('portfolio')">
        <router-link :to="'/model/'+model.slug" class="lm-link" :class="{current:(book=='portfolio')}" @click.native.prevent="clickBook($event)" event="">
            Portfolio
        </router-link>
        <br>
    </template>

    <template v-if="book_visible('runway')">
        <router-link :to="'/model/'+model.slug+'/runway'" class="lm-link" :class="{current:(book=='runway')}" @click.native.prevent="clickBook($event)" event="">
            Runway
        </router-link>
        <br>
    </template>

    <template v-if="book_visible('polaroids')">
        <router-link :to="'/model/'+model.slug+'/polaroids'" class="lm-link" :class="{current:(book=='polaroids')}" @click.native.prevent="clickBook($event)" event="">
            Polaroids
        </router-link>
        <br>
    </template>

    <template v-if="book_visible('portfolio')">
        <router-link :to="'/model/'+model.slug+'/full-book'" class="lm-link" :class="{current:(book=='full-book')}" @click.native.prevent="clickBook($event)" event="">
            Full book
        </router-link>
        <br>
    </template>

    <template v-if="model.instagram_link">
        <a :href="model.instagram_link" target="_blank" class="lm-link">
            Instagram
        </a>
        <br>
    </template>

    <template v-if="model.modelsdotcom_link">
        <a :href="model.modelsdotcom_link" class="lm-link" target="_blank">
            Models.com
        </a>
        <br>
    </template>


    <br><br>

    <div class="valtoggler">
        <span class="val" :class="{active:(metrics == 'eu')}" @click="setMetrics('eu')">EU</span> / 
        <span class="val" :class="{active:(metrics == 'us')}" @click="setMetrics('us')">US</span>
    </div>
    

    

    <table class="lstats">
        <tr v-if="model.age">
            <td>Age</td>
            <td>{{model.age}}</td>
        </tr>
        <tr v-if="model.height_cm">
            <td>Height</td>
            <td>
                <span class="euval" v-if="metrics=='eu'">{{model.height_cm}}</span>
                <span class="usval" v-if="metrics=='us'">{{model.height_ftin}}</span>
            </td>
        </tr>
        <tr v-if="model.chest_cm">
            <td>Chest</td>
            <td>
                <span class="euval" v-if="metrics=='eu'">{{model.chest_cm}}</span>
                <span class="usval" v-if="metrics=='us'">{{model.chest_in.toFixed(0)}}</span>
            </td>
        </tr>        
        <tr v-if="model.waist_cm">
            <td>Waist</td>
            <td>
                <span class="euval" v-if="metrics=='eu'">{{model.waist_cm}}</span>
                <span class="usval" v-if="metrics=='us'">{{model.waist_in.toFixed(0)}}</span>
            </td>
        </tr>        
        <tr v-if="model.hips_cm">
            <td>Hips</td>
            <td>
                <span class="euval" v-if="metrics=='eu'">{{model.hips_cm}}</span>
                <span class="usval" v-if="metrics=='us'">{{model.hips_in.toFixed(0)}}</span>
            </td>
        </tr>                

        <tr v-if="model.hair_color">
            <td>Hair color</td>
            <td>{{model.hair_color}}</td>
        </tr>                

        <tr v-if="model.eye_color">
            <td>Eye color</td>
            <td>{{model.eye_color}}</td>
        </tr>                

        <tr v-if="model.dress_size_eu">
            <td>Size</td>
            <td>
                <span class="euval" v-if="metrics=='eu'">{{model.dress_size_eu}}</span>
                <span class="usval" v-if="metrics=='us'">{{model.dress_size_us}}</span>
            </td>
        </tr>                
        
        <tr v-if="model.shoe_size_eu">
            <td>Shoes</td>
            <td>
                <span class="euval" v-if="metrics=='eu'">{{model.shoe_size_eu}}</span>
                <span class="usval" v-if="metrics=='us'">{{model.shoe_size_us}}</span>
            </td>
        </tr>                

    </table>


    <div class="optionsbtn" :class="{open:showOptions}" @mouseleave="showOptions=false">
        <div class="tbtn" @click="toggleOptions()">Options</div>
        <div class="sbtns">
            <a class="sbtn" target="_blank" :href="base_url+'pdf/model_setcard/'+model.slug">Download setcard</a>
            <a class="sbtn" target="_blank" :href="base_url+'pdf/model_polaroids/'+model.slug">Download polaroids</a>
            <a class="sbtn" target="_blank" :href="base_url+'download_full_book/model/'+model.slug">Download full book</a>            
        </div>
    </div>


    <template v-if="loggedin_user && false">

        <br><br>

        <router-link class="lm-link lvl1" :to="'/admin'">Admin</router-link><br>
        <router-link class="lm-link lvl1" :to="'/admin/model/'+model.id">Edit {{model.first_name}}</router-link><br>

        <div class="lm-link lvl1 trigger-layout-block-edit-mode-btn" v-if="!editing_blocks && this.book != 'full-book'" @click="editLayout()">
            Edit layout
        </div>

    </template>

</div>

</template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		
	},

	data(){ return {                            
        showOptions: false,
	}},


	computed: {

		book(){
			var book = this.route.params.book
			if( !book ) book = 'portfolio'
			return book
        },

        model(){ return this.$store.state.loaded_model },

        lastRoute(){ return this.$store.state.route.previous[0] },

        lastModelListPageRoute(){
            var routes = this.$store.state.route.previous
            for( let i = 0; i < routes.length; i++ ) {
                var r = routes[i]
                if( r.meta && r.meta.bodyClass && r.meta.bodyClass == 'page-models-list' ) {
                    return -(i+1)
                    //return r
                }
            }
        },

	},

	methods: {

        toggleOptions(){
            this.modal_open({ modal:'model_options' })
            //this.showOptions = !this.showOptions
        },
        
        
        book_visible(book_slug){            
            if( this.loggedin_user ) return true
            if( !this.model.books ) return false
            if( !this.model.books[book_slug] ) return false
            if( !this.model.books[book_slug].length ) return false            

            var blocks = this.model.books[book_slug]
            blocks = helpers.blocks_filter_capbelowblock(blocks)
            blocks = helpers.blocks_filter_nohideblocks(blocks)
            
            if( !blocks.length ) return false

            return true
        },

        clickBook(e)
		{

			//this.$router.push(e.target.getAttribute('href'))
			//return true

			//if( this.book == 'biography' ) {
			//	this.$router.push(e.target.getAttribute('href'))
			//	return true
			//}

			var _this = this
			var el = e.target		
			var link = el.getAttribute('href')      
			var $blockareas = document.querySelectorAll('.blocks .area')
			
			$blockareas.forEach(($el) => { $el.classList.add('fading-away-inactive') })

			setTimeout(()=>{
				_this.$router.push(link)				
			}, 350)

			setTimeout(()=>{			
				$blockareas.forEach(($el) => { $el.classList.remove('fading-away-inactive') })
			}, 400)
			
        },

        

	},

	created(){
		
	},

}
</script>



// WEBPACK FOOTER //
// src/views/LeftMenuModel.vue